var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6667 8.60294L17.5833 4.63529L16.8056 3.85294L13.6667 7.01029L12.0833 5.41765L11.3056 6.22794L13.6667 8.60294ZM0 19.5V17.2647H13.3333V19.5H0ZM14.4444 11.6765C12.9074 11.6765 11.5974 11.1314 10.5144 10.0414C9.43148 8.95127 8.88963 7.63357 8.88889 6.08824C8.88815 4.5429 9.43 3.2252 10.5144 2.13512C11.5989 1.04504 12.9089 0.5 14.4444 0.5C15.98 0.5 17.2904 1.04504 18.3756 2.13512C19.4607 3.2252 20.0022 4.5429 20 6.08824C19.9978 7.63357 19.4559 8.95165 18.3744 10.0425C17.293 11.1333 15.983 11.678 14.4444 11.6765ZM0 10.5588V8.32353H7C7.12963 8.73333 7.27778 9.12451 7.44444 9.49706C7.61111 9.86961 7.81481 10.2235 8.05555 10.5588H0ZM0 15.0294V12.7941H10.4444C10.8704 13.0549 11.3241 13.274 11.8056 13.4513C12.287 13.6286 12.7963 13.7542 13.3333 13.8279V15.0294H0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector (1).93c080c90355b254745b7ad7629fcd18.svg";
export { ForwardRef as ReactComponent };